import { Modal } from "ant-design-vue";

// Modal único de exclusão de rascunho: footer do cadastro e ação da listagem.
export function confirmDeleteDraft({ descricao, codigo, onOk }) {
  const nome = [descricao, codigo].filter(Boolean).join(" - ");

  Modal.confirm({
    title: "Excluir rascunho",
    icon: (h) =>
      h("a-icon", { props: { type: "close-circle", theme: "filled" } }),
    content: (h) =>
      h("span", [
        nome ? "O rascunho " : "Este rascunho",
        nome ? h("strong", nome) : null,
        " será excluído permanentemente. Todas as informações preenchidas serão perdidas. Deseja continuar?",
      ]),
    okText: "Excluir",
    okType: "danger",
    cancelText: "Cancelar",
    class: "freight-tables-confirm freight-tables-confirm--danger",
    onOk,
  });
}
